(function () {
  function fmt(c) { var n = c / 100; return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function toast(msg) {
    var t = document.createElement('div'); t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:30px;transform:translateX(-50%);z-index:100;padding:14px 22px;border-radius:18px;color:#F0ECDE;font-size:13px;background:rgba(59,44,39,.86);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px)';
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2600);
  }
  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-lb-card]'));
    var countEl = root.querySelector('[data-lb-count]'), totalEl = root.querySelector('[data-lb-total]'), ptsEl = root.querySelector('[data-lb-pts]'), btn = root.querySelector('[data-lb-add]');
    function cur(card) { return card.querySelector('.fio-lb__opt:not([hidden])'); }
    function update() {
      var on = cards.filter(function (c) { return c.dataset.on === '1'; });
      var total = 0;
      on.forEach(function (c) { var o = cur(c), s = o.querySelector('.fio-lb__size.is-sel'); total += +(s ? s.dataset.price : o.dataset.price); });
      var full = on.length === cards.length && cards.length >= 3;
      var pts = Math.floor(total / 100);
      countEl.textContent = on.length + (on.length === 1 ? ' peça' : ' peças');
      totalEl.textContent = fmt(total);
      ptsEl.textContent = pts.toLocaleString('pt-BR') + ' pontos no Clube';
      btn.textContent = 'Adicionar o look · ' + fmt(total);
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-lb-toggle]'))) { card.dataset.on = card.dataset.on === '1' ? '0' : '1'; update(); return; }
        if ((t = e.target.closest('[data-lb-prev],[data-lb-next]'))) {
          var n = +card.dataset.n, o = cur(card), i = +o.dataset.lbOpt;
          i = (i + (t.hasAttribute('data-lb-next') ? 1 : -1) + n) % n;
          o.hidden = true; card.querySelector('[data-lb-opt="' + i + '"]').hidden = false; update(); return;
        }
        if ((t = e.target.closest('[data-lb-size]')) && !t.disabled) {
          var opt = t.closest('.fio-lb__opt');
          opt.querySelectorAll('.fio-lb__size').forEach(function (b) { b.classList.toggle('is-sel', b === t); });
          var h = opt.querySelector('[data-lb-hint]'); h.textContent = 'Tamanho ' + t.dataset.size; h.classList.add('is-ok');
          card.dataset.on = '1'; update();
        }
      });
    });
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-busy')) return;
      var on = cards.filter(function (c) { return c.dataset.on === '1'; }), items = [], miss = null;
      on.forEach(function (c) { var o = cur(c), s = o.querySelector('.fio-lb__size.is-sel'); if (!s) { if (!miss) miss = o; } else items.push({ id: +s.dataset.lbSize, quantity: 1 }); });
      if (miss) { toast('Escolha o tamanho de ' + miss.querySelector('.fio-lb__meta a').textContent.trim()); var h = miss.querySelector('[data-lb-hint]'); if (h.animate) h.animate([{ opacity: 1 }, { opacity: .2 }, { opacity: 1 }], { duration: 600, iterations: 2 }); return; }
      btn.classList.add('is-busy');
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (data) {
          btn.classList.remove('is-busy');
          if (drawer && data.sections && drawer.renderContents) {
            var item = data.items && data.items[0] ? data.items[0] : {}; item.sections = data.sections; drawer.renderContents(item);
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else { toast('Look com ' + items.length + ' peças na sacola'); }
        })
        .catch(function (err) { btn.classList.remove('is-busy'); toast((err && err.description) || 'Não foi possível adicionar. Tente de novo.'); });
    });
    update();
  }
  function boot() { document.querySelectorAll('[data-fio-lb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
